import { Components, Theme } from "@mui/material";

export const MuiStepConnector: Components<
  Omit<Theme, "MuiStepConnector">
>["MuiStepConnector"] = {
  styleOverrides: {
    root: {
      marginLeft: "16px",
    },
    line: ({ theme: { palette } }) => ({
      borderColor: palette.custom.purple[400],
    }),
  },
};
